import { render, staticRenderFns } from "./Filebrowser.vue?vue&type=template&id=cfdcdb5a&scoped=true&"
import script from "./Filebrowser.vue?vue&type=script&lang=js&"
export * from "./Filebrowser.vue?vue&type=script&lang=js&"
import style0 from "./Filebrowser.vue?vue&type=style&index=0&id=cfdcdb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdcdb5a",
  null
  
)

export default component.exports